import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { api } from "../lib/api";

const AdminLogin = () => {
  const { loginAdmin, t } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await loginAdmin(email, password);
      navigate("/admin");
    } catch (ex) {
      setErr(typeof ex?.response?.data?.detail === "string" ? ex.response.data.detail : "Login failed");
    } finally { setLoading(false); }
  };

  const submitForgot = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setForgotSent(true);
    } catch (ex) {
      setErr(typeof ex?.response?.data?.detail === "string" ? ex.response.data.detail : "Gagal mengirim email");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5">
      {forgot ? (
        <form onSubmit={submitForgot} className="w-full max-w-sm bg-white rounded-2xl border border-border/60 p-8 shadow-soft" data-testid="admin-forgot-form">
          <h1 className="font-serif text-3xl text-holy-red mb-1">Lupa Password</h1>
          <p className="text-xs text-muted-foreground mb-6">Masukkan email admin. Link reset akan dikirim ke email tersebut (berlaku 1 jam).</p>
          {forgotSent ? (
            <div className="text-center space-y-3" data-testid="admin-forgot-success">
              <div className="text-4xl">📧</div>
              <p className="text-sm">Link reset password telah dikirim. Silakan cek inbox (atau folder spam).</p>
              <button type="button" onClick={() => { setForgot(false); setForgotSent(false); }} className="text-holy-red text-sm font-semibold hover:underline" data-testid="admin-forgot-back">
                ← Kembali ke Login
              </button>
            </div>
          ) : (
            <>
              <label className="block text-xs uppercase tracking-widest mb-1 text-muted-foreground">Email</label>
              <input data-testid="admin-forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-base mb-4" />
              {err && <div className="text-sm text-holy-red mb-3" data-testid="admin-forgot-error">{err}</div>}
              <button data-testid="admin-forgot-submit" disabled={loading} className="w-full bg-holy-red text-ivory rounded-full py-3 hover:-translate-y-0.5 transition-all disabled:opacity-60 mb-3">
                {loading ? "..." : "Kirim Link Reset"}
              </button>
              <button type="button" onClick={() => setForgot(false)} className="w-full text-sm text-muted-foreground hover:text-holy-red" data-testid="admin-forgot-cancel">
                ← Kembali
              </button>
            </>
          )}
          <style>{`.input-base{background:#fff;border:1px solid hsl(var(--border));padding:.75rem 1rem;border-radius:.75rem;font-size:.875rem;outline:none;width:100%}.input-base:focus{border-color:#9B1C26;box-shadow:0 0 0 3px rgba(155,28,38,.1)}`}</style>
        </form>
      ) : (
        <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl border border-border/60 p-8 shadow-soft">
          <h1 className="font-serif text-3xl text-holy-red mb-1">{t("nav_admin")}</h1>
          <p className="text-xs text-muted-foreground mb-6">Sign in to manage Holy Flowy</p>
          <label className="block text-xs uppercase tracking-widest mb-1 text-muted-foreground">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-base mb-4" />
          <label className="block text-xs uppercase tracking-widest mb-1 text-muted-foreground">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-base mb-2" />
          <div className="text-right mb-4">
            <button type="button" onClick={() => { setForgot(true); setErr(""); }} className="text-xs text-holy-gold-dark hover:text-holy-red font-semibold" data-testid="admin-link-forgot">
              Lupa Password?
            </button>
          </div>
          {err && <div className="text-sm text-holy-red mb-3" data-testid="login-error">{err}</div>}
          <button data-testid="login-submit" disabled={loading} className="w-full bg-holy-red text-ivory rounded-full py-3 hover:-translate-y-0.5 transition-all disabled:opacity-60">
            {loading ? "..." : t("login")}
          </button>
          <style>{`.input-base{background:#fff;border:1px solid hsl(var(--border));padding:.75rem 1rem;border-radius:.75rem;font-size:.875rem;outline:none;width:100%}.input-base:focus{border-color:#9B1C26;box-shadow:0 0 0 3px rgba(155,28,38,.1)}`}</style>
        </form>
      )}
    </div>
  );
};

export default AdminLogin;
